const configMicro = {
  API_URL: process.env.REACT_APP_DEV_MICRO_APP,
  DEFAULT_REQUEST_TIMEOUT: 320000,
};

export default configMicro;
